import React from "react";

export const INVOICE_FIELDS = [
  ["seller", "SELLER / EXPORTER"], ["consignee", "BUYER / CONSIGNEE"],
  ["delivery_address", "SHIP TO / DELIVERY ADDRESS"], ["incoterms", "INCOTERMS"],
  ["shipping_method", "SHIPPING"], ["carrier", "CARRIER"], ["plan_no", "PLAN NO"],
  ["country", "COUNTRY"], ["date", "DATE"], ["currency", "CURRENCY"],
].map(([field, label]) => ({ field, label }));
export const DEFAULT_INVOICE_CARDS = INVOICE_FIELDS.slice(0, 3);

export function InvoiceInfoCardControls({ template, mutate }) {
  const cards = template.options.invoice_info_cards || [];
  const move = (index, step) => mutate(t => {
    const target = index + step;
    if (target < 0 || target >= cards.length) return;
    [t.options.invoice_info_cards[index], t.options.invoice_info_cards[target]] = [t.options.invoice_info_cards[target], t.options.invoice_info_cards[index]];
  });
  return <section className="border-t pt-4 space-y-2" data-testid="invoice-info-cards">
    <div className="label">Bilgi Kartları</div><p className="text-xs text-slate-500">Alıcı ve teslimat adresi ayrı kartlarda gösterilir. Başlıkları değiştirip kartları sıralayabilirsiniz.</p>
    {cards.map((card, index) => <div key={card.field} className="border p-2">
      <div className="flex gap-2 items-center"><input aria-label={`${card.field} başlığı`} className="input flex-1" value={card.label} onChange={e => mutate(t => { t.options.invoice_info_cards[index].label = e.target.value; })} />
        <button aria-label="Yukarı taşı" onClick={() => move(index, -1)}>↑</button><button aria-label="Aşağı taşı" onClick={() => move(index, 1)}>↓</button>
        <button aria-label="Kartı kaldır" onClick={() => mutate(t => { t.options.invoice_info_cards.splice(index, 1); })}>×</button></div>
      <small className="text-slate-400">{INVOICE_FIELDS.find(f => f.field === card.field)?.label}</small>
    </div>)}
    <select className="input" aria-label="Bilgi kartı ekle" value="" onChange={e => { const card = INVOICE_FIELDS.find(f => f.field === e.target.value); if (card) mutate(t => { t.options.invoice_info_cards.push({ ...card }); }); }}>
      <option value="">+ Bilgi kartı ekle</option>{INVOICE_FIELDS.filter(f => !cards.some(c => c.field === f.field)).map(f => <option key={f.field} value={f.field}>{f.label}</option>)}
    </select>
  </section>;
}

export function InvoiceInfoCardPreview({ template, sample }) {
  const theme = template.theme;
  const sections = Object.fromEntries((template.sections || []).map(s => [s.key, s.visible !== false]));
  const values = { seller: `${sample.company}\nIstanbul, Türkiye\nsales@example.com`, consignee: `${sample.buyer}\n${sample.address}`, delivery_address: "Warehouse / Delivery address\nBristol, United Kingdom", ...sample };
  return <div className="grid grid-cols-2 gap-3 mt-4">{(template.options.invoice_info_cards || []).filter(c => c.field === "seller" ? sections.seller !== false : ["consignee", "delivery_address"].includes(c.field) ? sections.buyer !== false : true).map(c => <div key={c.field} className="border" style={{ borderColor: theme.border_color }}>
    <div className="px-3 py-1.5 font-bold" style={{ background: theme.header_background, color: theme.header_text }}>{c.label}</div>
    <div className="p-3 whitespace-pre-line break-words">{values[c.field] || "—"}</div>
  </div>)}</div>;
}
